import {useFetchData} from 'hooks/api/useFetchData'
import {Position} from 'types/api/positions/position'

export const useFetchPositions = () => {
  const path = '/api/positions'
  return useFetchData<Position[]>(path, [], {})
}
